import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface IProps {
  title: string | ReactNode;
  children?: ReactNode;
}

const Title = styled.h1`
  margin: 0;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font: inherit;
  font-size: 22px;
  font-weight: 600;
  line-height: normal;
  color: ${theme.colors.secondary900};
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export default ({ title, children }: IProps) => {
  if (children) {
    return (
      <Wrapper>
        <Title>{title}</Title>
        {children}
      </Wrapper>
    );
  }

  return <Title>{title}</Title>;
};
